import { atom } from 'jotai';

import { CorridorParameterMarginsMap } from '@data';

export const corridorsAtom = atom<CorridorParameterMarginsMap>();
